<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title has-text-grey-dark">{{ titulo }}</div>
      <div v-if="rutaSuperior" class="card-header-icon">
        <router-link
          :to="rutaSuperior.ruta"
          tag="b-button"
          class="is-secundary"
        >{{ rutaSuperior.texto }}</router-link>
      </div>
    </div>
    <div class="card-content">
      <router-link :to="rutaInferior.ruta" tag="a">
        <figure class="image">
          <Ribbon v-if="false" text color="#51b982" position="right-top" />
          <img :src="imageSrc" @error="imageUrlAlt" />
        </figure>
      </router-link>
    </div>
    <footer v-if="rutaInferior" class="card-footer">
      <div v-if="precio" class="card-footer-item">
        <div v-if="precio.formato === 'simple'" class="title is-5">{{precio.valor}}</div>
        <b-taglist attached v-else>
          <b-tag type="is-primary">{{ precio.moneda }}</b-tag>
          <b-tag type="is-info">{{ precio.valor }}</b-tag>
        </b-taglist>
      </div>
      <div class="card-footer-item">
        <router-link
          :to="rutaInferior.ruta"
          tag="b-button"
          class="is-secundary"
        >{{ rutaInferior.texto }}</router-link>
      </div>
    </footer>
  </div>
</template>

<style scoped lang="scss">
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: scale(1.07);
}
.card {
  box-shadow: 0 0.5em 1em -0.125em grey, 0 0px 0 1px grey;
}
</style>

<script>
import Ribbon from 'vue-ribbon'
import ImagenPorDefecto from '@/assets/img/productos/default.png'

export default {
  name: 'CardProducto',
  components: {
    Ribbon
  },
  props: {
    titulo: {
      type: String,
      required: true
    },
    imageSrc: {
      type: String,
      required: true
    },
    rutaSuperior: {
      type: Object,
      default: null
    },
    rutaInferior: {
      type: Object,
      default: null
    },
    precio: {
      type: Object,
      default: null
    }
  },
  methods: {
    imageUrlAlt (event) {
      event.target.src = ImagenPorDefecto
    }
  }
}
</script>
